import styled from 'styled-components';
import { LanguageSwitcherStyled } from '../LanguageSwitcherStyled';

export const LanguageSwitcherStyledOV = styled(LanguageSwitcherStyled)``;
